module.exports = __webpack_public_path__ + "img/A - 02.46c7bdeb.png";